// https://redux.js.org/recipes/usage-with-typescript#type-checking-reducers

import {combineReducers} from "redux"

import xTestSlice from "./test";


const rootReducer = combineReducers({
    // uses Redux Toolkit slices (much less boilerplate code)
    test: xTestSlice.reducer,
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
